import { createFileRoute } from "@tanstack/react-router";
import MapView from "lib/components/builders/communities/map/MapView";
import styles from "lib/components/builders/communities/map/PublicMapPage.module.scss";
import Page from "lib/components/layout/Page";

function PublicMapPage() {
  return (
    <Page className={styles.wrapper} pageTitle="Community Map">
      <MapView isPublic />
    </Page>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/sales-map/")({
  component: PublicMapPage,
  staticData: { isPublicPage: true },
});
